import {
    DOWNLOAD_TEMPLATE,
    DOWNLOAD_TEMPLATE_SUCCESS,
    DOWNLOAD_TEMPLATE_FAILED,

    UPLOAD,
    UPLOAD_SUCCESS,
    UPLOAD_FAILED,
} from './constants';

const INIT_STATE = {
    loading: false,
    error: null
};

const masterDataReducers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPLOAD:
            return {...state, loading: true};
        case UPLOAD_SUCCESS:
            return {...state, loading: false, error: null};
        case UPLOAD_FAILED:
            return {...state, error: action.payload, loading: false};
        case DOWNLOAD_TEMPLATE:
            return {...state, loading: true};
        case DOWNLOAD_TEMPLATE_SUCCESS:
            return {...state, loading: false, error: null};
        case DOWNLOAD_TEMPLATE_FAILED:
            return {...state, error: action.payload, loading: false};
        default:
            return { ...state };
    }
};

export default masterDataReducers;
